import type { ReactNode } from "react"

/**
 * What a conversation pane shows before anything is picked, in both inboxes.
 *
 * The illustration is drawn here rather than served from `public/`: it has to be
 * right in light and dark, and `currentColor` over theme tokens is what does that
 * without shipping two assets.
 */
export function ConversationEmptyState({
  title,
  description,
  footer,
}: {
  title: string
  description: string
  footer?: ReactNode
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-5 p-8 text-center">
      <ConversationIllustration />
      <div className="max-w-xs space-y-1.5">
        <h2 className="text-sm font-medium text-foreground">{title}</h2>
        <p className="text-xs leading-relaxed text-muted-foreground">{description}</p>
      </div>
      {footer}
    </div>
  )
}

function ConversationIllustration() {
  return (
    <svg
      viewBox="0 0 120 84"
      role="presentation"
      aria-hidden="true"
      className="h-20 w-auto text-muted-foreground/35"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Two bubbles mid-exchange: the incoming one behind, the answer in front. */}
      <path
        d="M14 10h62a8 8 0 0 1 8 8v26a8 8 0 0 1-8 8H36l-14 11V52h-8a8 8 0 0 1-8-8V18a8 8 0 0 1 8-8Z"
        className="fill-muted/50"
      />
      <path d="M26 24h38M26 36h24" className="text-muted-foreground/60" />
      <path
        d="M52 40h54a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H72l-12 9V74h-8a8 8 0 0 1-8-8V48a8 8 0 0 1 8-8Z"
        className="fill-background"
      />
      <path d="M64 53h30M64 63h18" className="text-muted-foreground/60" />
    </svg>
  )
}
